import { useEffect, useState } from 'react';
import { DataTableSearchKeyword, DataTableSortContent, DataTableSortField } from '@/components/element/types';
import { DataTableSortEvent } from 'primereact/datatable';
import { storage } from '@/lib/storage';

export const useDataTableSortContent = (identifier: string) => {
  const [dataTableSortField, setDataTableSortField] = useState<DataTableSortField>();
  const [dataTableSearchKeyword, setDataTableSearchKeyword] = useState<DataTableSearchKeyword>();
  const [dataTableSortContent, setDataTableSortContent] = useState<DataTableSortContent>({
    dataTableSortField: undefined,
    dataTableSearchKeyword: undefined,
  });

  useEffect(() => {
    const _dtContent = storage.dataTableSortContent.get(identifier);
    if (_dtContent) {
      setDataTableSortContent(_dtContent);
    } else {
      setDataTableSortContent({
        dataTableSortField: undefined,
        dataTableSearchKeyword: undefined,
      });
    }
  }, [identifier]);

  const onSort = (e: DataTableSortEvent) => {
    if (e.sortField != null) {
      dataTableSortContent.dataTableSortField = { filed: e.sortField, sortOrder: e.sortOrder };
    } else {
      dataTableSortContent.dataTableSortField = undefined;
    }

    setDataTableSortContent({
      dataTableSortField: dataTableSortContent.dataTableSortField,
      dataTableSearchKeyword: dataTableSortContent.dataTableSearchKeyword,
    });
    storage.dataTableSortContent.set(identifier, dataTableSortContent);
  };

  const onKeywordChanged = (keyword: string | undefined) => {
    if (keyword != null && keyword.length > 0) {
      dataTableSortContent.dataTableSearchKeyword = { keyword };
    } else {
      dataTableSortContent.dataTableSearchKeyword = undefined;
    }

    setDataTableSortContent({
      dataTableSortField: dataTableSortContent.dataTableSortField,
      dataTableSearchKeyword: dataTableSortContent.dataTableSearchKeyword,
    });
    storage.dataTableSortContent.set(identifier, dataTableSortContent);
  };

  return {
    dataTableSortContent,
    dataTableSortField: dataTableSortContent.dataTableSortField,
    dataTableSearchKeyword: dataTableSortContent.dataTableSearchKeyword,
    onSort,
    onKeywordChanged,
  };
};
